export const EIP_EXCHANGE_ADDON_ID = '32d01677-5327-aaab-dbc6-24f0c79d09cc';
export const REDIRECT_PATH_KEY = 'redirectPath';
// The online model of the products like Mobile subscription, broadband, nettilite, ring currently has
// 1 commercial product per offer unlike devices. If later support for multiple products are added this variable
// can be removed
export const SELECTED_COMMERCIAL_PRODUCT_INDEX = 0;
export const ITEMS_QUERY_LIMIT = 30;
